/** 発送予定行の完了段階（0=通常, 1=基幹完了, 2=Wチェック済） */
export function getShipmentRowStage(compflag, wCheck) {
  if (wCheck && String(wCheck).trim()) {
    return 2;
  }
  if (String(compflag ?? '').trim() === '*') {
    return 1;
  }
  return 0;
}

/** 一覧行の背景・ボーダー用 Tailwind クラス（印刷時は index.css で無効化） */
export function getShipmentRowClassName(stage, { hoverable = true } = {}) {
  if (stage === 2) {
    return 'bg-slate-200 shipment-row-stage-2';
  }
  if (stage === 1) {
    return 'bg-amber-50 border-l-4 border-amber-300 shipment-row-stage-1';
  }
  return hoverable ? 'hover:bg-slate-50' : '';
}

export const SHIPMENT_ROW_LEGEND = '薄い色＝基幹完了（Wチェック待ち）／濃い色＝Wチェック済';

/** sticky 列の背景（行の段階に合わせる） */
export function getShipmentRowStickyCellClassName(stage) {
  if (stage === 2) {
    return 'bg-slate-200';
  }
  if (stage === 1) {
    return 'bg-amber-50';
  }
  return 'bg-white';
}
